// ── 로그 관리 — 모바일 카드 목록 컴포넌트 ────────────────────────────────────
import React from 'react';
import { statusColor, methodColor, fmtDatetime, shortPath, formatBodyRows } from './formatters';
import { resolveActionDescription } from './resolveActionDescription';
import { resolveFeatureLabel } from './formatters';
import {
  placeholderStyle, mobileLogListStyle, mobileLogCardStyle,
  mobileCardTopStyle, mobileCardNameStyle, mobileCardSubStyle, mobileCardTimeStyle,
  mobilePathStyle, mobileIpStyle, mobileExpandStyle, mobileExpandRowStyle,
  featureBadgeStyle, methodBadgeStyle, statusBadgeStyle,
  expandLabelStyle, actionLabelStyle, actionDetailStyle,
  bodyTableStyle, bodyKeyTdStyle, bodyValTdStyle, jsonPreStyle,
} from './styles';

/**
 * 로그 모바일 카드 목록 — 각 카드 클릭으로 request_body 상세 확장
 * @param {object[]} logs        — 현재 페이지 로그 목록
 * @param {number|null} expandedId — 현재 확장된 로그 ID
 * @param {Function} onToggleExpand — 확장 토글 콜백 (logId) => void
 */
export function LogMobileList({ logs, expandedId, onToggleExpand }) {
  if (logs.length === 0) {
    return <div style={placeholderStyle}>로그가 없습니다.</div>;
  }

  return (
    <div style={mobileLogListStyle}>
      {logs.map((log) => {
        const sc          = statusColor(log.status_code);
        const mc          = methodColor(log.method);
        const featureInfo = resolveFeatureLabel(log.path);
        const actionDesc  = resolveActionDescription(log.path, log.method, log.request_body);
        const bodyRows    = formatBodyRows(log.request_body);
        const isExpanded  = expandedId === log.id;

        return (
          <div
            key={log.id}
            style={mobileLogCardStyle}
            onClick={() => onToggleExpand(log.id)}
          >
            {/* 카드 상단: 직원명 + 시각 */}
            <div style={mobileCardTopStyle}>
              <div>
                <span style={mobileCardNameStyle}>{log.actor_name || '-'}</span>
                {log.actor_login_id && (
                  <span style={mobileCardSubStyle}> · {log.actor_login_id}</span>
                )}
              </div>
              <span style={mobileCardTimeStyle}>{fmtDatetime(log.created_at)}</span>
            </div>

            {/* 기능 + 메서드 + 상태 배지 */}
            <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', marginTop: 6 }}>
              {featureInfo && (
                <span style={{ ...featureBadgeStyle, color: featureInfo.color, background: featureInfo.color + '18', border: `1px solid ${featureInfo.color}30` }}>
                  {featureInfo.label}
                </span>
              )}
              <span style={{ ...methodBadgeStyle, background: mc.bg, color: mc.text }}>{log.method}</span>
              <span style={{ ...statusBadgeStyle, background: sc.bg, color: sc.text }}>{log.status_code}</span>
              {log.ip_address && <span style={mobileIpStyle}>{log.ip_address}</span>}
            </div>

            {/* 한국어 동작 설명 */}
            {actionDesc && (
              <div style={{ marginTop: 4 }}>
                <span style={actionLabelStyle}>{actionDesc.label}</span>
                {actionDesc.detail && <span style={actionDetailStyle}> {actionDesc.detail}</span>}
              </div>
            )}

            {/* PATH 축약 */}
            <div style={mobilePathStyle}>{shortPath(log.path)}</div>

            {/* 확장: 한국어 필드 표 + 전체 PATH + JSON */}
            {isExpanded && (
              <div style={mobileExpandStyle}>
                {/* 한국어 필드 표 */}
                {bodyRows.length > 0 && (
                  <div style={mobileExpandRowStyle}>
                    <span style={{ ...expandLabelStyle, marginBottom: 4, display: 'block' }}>요청 내용 (한국어)</span>
                    <table style={bodyTableStyle}>
                      <tbody>
                        {bodyRows.map(({ key, label, value }) => (
                          <tr key={key}>
                            <td style={bodyKeyTdStyle}>{label}</td>
                            <td style={bodyValTdStyle}>{value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {/* 전체 PATH */}
                <div style={mobileExpandRowStyle}>
                  <span style={expandLabelStyle}>전체 PATH</span>
                  <span style={{ fontFamily: 'monospace', fontSize: 11, color: 'var(--text-sub)', wordBreak: 'break-all' }}>{log.path}</span>
                </div>
                {/* User-Agent */}
                {log.user_agent && (
                  <div style={mobileExpandRowStyle}>
                    <span style={expandLabelStyle}>User-Agent</span>
                    <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{log.user_agent}</span>
                  </div>
                )}
                {/* 날것 JSON */}
                {log.request_body ? (
                  <div style={{ marginTop: 6 }}>
                    <div style={{ ...expandLabelStyle, marginBottom: 4 }}>Request Body (JSON)</div>
                    <pre style={jsonPreStyle}>{JSON.stringify(log.request_body, null, 2)}</pre>
                  </div>
                ) : (
                  <div style={{ fontSize: 11, color: 'var(--text-muted)', fontStyle: 'italic', marginTop: 4 }}>요청 바디 없음</div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
